import { useEffect } from "react";
import { useLocation } from "react-router";
import { analytics, captureAttribution } from "../utils/rudderstack";

export const RudderStackTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Persist any click IDs / UTMs on this URL before the next navigation can
    // strip the query string, then record the page view.
    captureAttribution();
    analytics.page();
  }, [location]);

  return null;
};
